export interface BingoResolution {
  id: string;
  title: string;
  goalTally: number;
  currentTally: number;
  color: string;
  note: string;
  updatedAt: Date;
}

function getBingoResolutionFromData(data: any): BingoResolution {
  return {
    id: data.id,
    title: data.title,
    goalTally: data.goal_tally,
    currentTally: data.current_tally,
    color: data.color,
    note: data.note,
    updatedAt: new Date(data.updated_at),
  };
}

export function getBingoResolutionFromDataList(
  dataList: any[]
): BingoResolution[] {
  return dataList.map((data) => getBingoResolutionFromData(data));
}

export function getTitleToDisplay(title: string): string {
  return title && title !== "" ? title : "...";
}
